import PlatformNotificationsList from './PlatformNotificationsList.vue'

export default PlatformNotificationsList